import React, {useCallback} from 'react';
import MuiDialogActions from '@mui/material/DialogActions';
import Dialog, {DialogProps} from 'components/Dialog';
import {Theme} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from 'components/Button';
import {useTranslation} from 'react-i18next';
import {DialogTypes} from 'common/names';
import {useDispatch, useSelector} from 'react-redux';
import {serverAction, serverSelectors, serverTypes} from 'redux/server';
import {LoaderInline} from 'components/Loader';

const DialogActions = withStyles((theme: Theme) => ({
   root: {
      margin: 0,
      padding: theme.spacing(1),
   },
}))(MuiDialogActions);

const contentStyles = {flex: '0 1 auto', margin: '0 1rem', overflow: 'auto'};

type Props = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   onClose?: () => void;
   maxWidth?: DialogProps['maxWidth'];
};
export const ConnectionAuditReportDialog = (props: Props) => {
   const {
      open = true,
      content,
      title = DialogTypes.ConnectionAuditReportDialog.dialogName,
      onClose,
      maxWidth,
   } = props;
   const {t} = useTranslation();

   const dispatch = useDispatch();
   const run = useCallback(() => {
      dispatch(serverAction.downloadConnectionAuditReport());
      onClose?.();
   }, [dispatch, onClose]);
   const isFetching = useSelector(
      serverSelectors[serverTypes.DOWNLOAD_CONNECTION_AUDIT_REPORT._FETCHING]
   );

   return (
      <Dialog header={title} open={open} maxWidth={maxWidth} close={onClose}>
         <div style={contentStyles}>
            {t(`Diplomat MFT will make connections to all SFTP servers defined
in the system in order to assess the security of those servers.
When finished, a report will be downloaded by your web browser.

NOTE that this report may take a few minutes to generate, and it 
will run in the background.  You may continue other operations 
while it is processing.`)}
         </div>
         <DialogActions>
            <Button onClick={run}>{t('Run')}</Button>
            <Button onClick={onClose} color="primary">
               {t('Cancel')}
            </Button>
            {isFetching ? <LoaderInline /> : null}
         </DialogActions>
      </Dialog>
   );
};
